import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/newsletter")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", search: { tab: "newsletter" }, replace: true });
  },
});
